const RECENCY_CAP = 8;
const KEY_PREFIX = 'atlas.recentTypes';

export interface RecentTypeEntry {
  systemName: string;
  at: number;
}

function makeKey(orgId: string): string {
  return `${KEY_PREFIX}.${orgId}`;
}

export function recordRecentType(orgId: string, systemName: string): void {
  try {
    const existing = getRecentTypes(orgId);
    const deduped = existing.filter((e) => e.systemName !== systemName);
    const updated: RecentTypeEntry[] = [
      { systemName, at: Date.now() },
      ...deduped,
    ].slice(0, RECENCY_CAP);
    localStorage.setItem(makeKey(orgId), JSON.stringify(updated));
  } catch {
    // localStorage unavailable or quota exceeded — no-op
  }
}

export function getRecentTypes(orgId: string): RecentTypeEntry[] {
  try {
    const raw = localStorage.getItem(makeKey(orgId));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is RecentTypeEntry =>
        typeof e === 'object' &&
        e !== null &&
        typeof (e as RecentTypeEntry).systemName === 'string' &&
        typeof (e as RecentTypeEntry).at === 'number',
    );
  } catch {
    return [];
  }
}
